import React, { useEffect } from 'react';
import apiService from '../../../services/apiService';

/*
* This component returns user's role for a specific project 
*/
const ProjectRole = (props) => {

    const{
        project,
        updateData,
        projectRole,
        setProjectRole
    } = props;
    

    useEffect(()=>{

        const userLoginName = JSON.parse(localStorage.getItem('user')).login;

        apiService.getUserWithParam({ name: userLoginName})
        .then((response) => {
            if(response.data._id === project.owner){
                setProjectRole('owner');
            }
            else{
                setProjectRole('member');
            }
        })
        .catch((error) => {throw error;});

    },[updateData])

    return(
        <span>  
            {projectRole}
        </span>
    )

}

export default ProjectRole;